import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2051f11e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  id: "product_page"
}
const _hoisted_4 = { class: "product_sidebar" }
const _hoisted_5 = { class: "product-image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Pricing unavailable.")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Please ")
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" to view prices.")
const _hoisted_14 = {
  key: 1,
  id: "pricing-error-section"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The selected item is currently unpriceable.", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Contact ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" for availability.")
const _hoisted_18 = {
  key: 0,
  class: "project-info"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Active Project:", -1))
const _hoisted_20 = { class: "product-price-quantity" }
const _hoisted_21 = {
  key: 0,
  class: "product-quantity"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "item-quantity" }, "Quantity:", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Please request a quote for volume pricing: ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_25 = {
  key: 0,
  class: "product-actions"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Jambs")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Machine")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Prehang")
const _hoisted_30 = {
  key: 1,
  class: "project-info"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Active Project:", -1))
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "primary-content" }
const _hoisted_34 = {
  key: 2,
  class: "loading-container"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There was an issue loading this product. Please reload the page and try again.", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("If the issue persists, please contact us: ")

import { Product } from '@/types/product';
    import { ref, onMounted, watch } from 'vue'
    import useProductService from '@/services/product-service';
    import ProductForm from '@/components/product/ProductForm.vue';
    import LoadingDoorSvg from '@/components/LoadingDoorSvg.vue';
    import { WebsiteItem } from '@/types';
    import SimpleModal from '@/components/modals/SimpleModal.vue';
    import ProductPrice from './ProductPrice.vue';
    import cartService from '@/services/cart-service';
    import { useToast } from '@/composables/useToast';
    import { storeToRefs } from 'pinia'
    import { useCartStore } from '@/stores/cart'
    import { debounce } from 'lodash';
    import MailToQuotes from '@/components/MailToQuotes.vue';
    import { useAuthService } from '@/services/auth-service';
    import PreHangModal from '@/components/prehang/PreHangModal.vue';
    import { dispatchUpdateCartCountEvent } from '@/main';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPage',
  props: {
        productId: { type: String, required: true }
    },
  setup(__props) {

const props = __props

    

    const toast = useToast()
    const { cart } = storeToRefs(useCartStore())
    const { get } = useCartStore()
    const product = ref<Product | null >(null)
    const productService = useProductService()
    const isProductLoaded = ref<boolean>(false)
    const selections = ref<WebsiteItem>()
    const quantity = ref<number>(1)
    const isQtyWarningOpen = ref<boolean>(false)
    const hasPricingError = ref<boolean>(false)
    const isAddingToCart = ref<boolean>(false)
    const isSticky = ref<boolean>(false)
    const isPreHangOpen = ref<boolean>(false)
    const stickyOffset = ref<number>(9999)
    const isAuth = ref<boolean>(false)
    const authService = useAuthService()
    const loginURL = ref<string>('')

    function handleProductUpdate(properties: WebsiteItem) {
        selections.value = properties
    }

    window.addEventListener('scroll', applySticky)
    window.addEventListener('resize', debounce(getStickyOffset,200))

    function getStickyOffset() {
        if(!isSticky.value) {
            const stickyTarget = document.getElementById('priceable-section')
            if(stickyTarget) {
                const position = stickyTarget.getBoundingClientRect()
                stickyOffset.value = position.top + window.scrollY
            }
        } else {
            stickyOffset.value = 0
            isSticky.value = false
        }
    }
    
    function applySticky() {
        if(stickyOffset.value) {
            if(window.scrollY > stickyOffset.value) {
                isSticky.value = true
            } else {
                isSticky.value = false
            }
        } else {
            isSticky.value = false
            getStickyOffset()
        }
    }

    async function addToCart() {
        isAddingToCart.value = true
        try {
            let result = null
            if(selections.value && quantity.value) {
                result = await cartService.addItem(selections.value, quantity.value)
            }
            if(result) {
                toast.success(`Added ${quantity.value} ${product.value?.name} to Project: ${cart.value?.name}.`)
            } else {
                throw new Error(`Failed to add ${product.value?.name} to Project: ${cart.value?.name}. Refresh and try again. If the issue persists please contact: quotes@woodportdoors.com`)
            }
        } catch(err) {
            toast.error(err as string)
        } finally {
            isAddingToCart.value = false
            dispatchUpdateCartCountEvent()
        }
    }

    function addToCartSuccess(qty:number) {
        toast.success(`Added ${qty} ${product.value?.name} to Project: ${cart.value?.name}.`)
    }

    watch(quantity, () => {
        if(quantity.value > 50) {
            isQtyWarningOpen.value = true
            quantity.value = 50
        }
    })

    onMounted(async () => {
        isAuth.value = await authService.isAuth()
        await productService.getProduct(parseInt(props.productId)).then(result => {
            if(result) {
                product.value = result
                isProductLoaded.value = true
            }
        })
        await get()
        getStickyOffset()
        loginURL.value = `${process.env.VUE_APP_WEB_URL}/my-cart?redirect=${window.location.pathname.replace('/.website_a655f3b7', '')}&1=1#cart/login`
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isProductLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoadingDoorSvg)
        ]))
      : (isProductLoaded.value && product.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (selections.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: selections.value.imageUrl
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: product.value.image
                    }, null, 8, _hoisted_7))
              ]),
              (!isAuth.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", null, [
                      _hoisted_9,
                      _hoisted_10,
                      _hoisted_11,
                      _createElementVNode("a", { href: loginURL.value }, "login", 8, _hoisted_12),
                      _hoisted_13
                    ])
                  ]))
                : (product.value?.attributes?.['not-priceable'])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("p", null, [
                        _hoisted_16,
                        _createVNode(MailToQuotes, { product: selections.value }, null, 8, ["product"]),
                        _hoisted_17
                      ]),
                      (_unref(cart))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("h4", null, _toDisplayString(_unref(cart)?.name), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      id: "priceable-section",
                      class: _normalizeClass({'sticky': isSticky.value && !hasPricingError.value})
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(ProductPrice, {
                          item: selections.value,
                          onPriceError: _cache[0] || (_cache[0] = (hasError) => hasPricingError.value = hasError),
                          "price-adjust": _unref(cart)?.priceAdjust
                        }, null, 8, ["item", "price-adjust"]),
                        (!hasPricingError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _hoisted_22,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((quantity).value = $event)),
                                type: "number",
                                id: "item-quantity",
                                min: "1",
                                max: "100",
                                step: "1"
                              }, null, 512), [
                                [_vModelText, quantity.value]
                              ]),
                              (isQtyWarningOpen.value)
                                ? (_openBlock(), _createBlock(SimpleModal, {
                                    key: 0,
                                    onHidden: _cache[2] || (_cache[2] = () => isQtyWarningOpen.value = false),
                                    title: "Maximum Quantity of 50 Exceeded",
                                    "show-footer": false
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_23,
                                      _createVNode(MailToQuotes, { product: selections.value }, null, 8, ["product"]),
                                      _hoisted_24
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (!hasPricingError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("button", {
                              id: "addToCart",
                              class: "btn btn-primary",
                              onClick: addToCart,
                              disabled: isAddingToCart.value
                            }, "Add to cart", 8, _hoisted_26),
                            _createElementVNode("button", {
                              id: "prehang-btn",
                              class: "btn btn-secondary",
                              onClick: _cache[3] || (_cache[3] = () => {isPreHangOpen.value = true})
                            }, [
                              (product.value.name.toLowerCase().includes('bifold'))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_27
                                  ], 64))
                                : ((product.value.name.toLowerCase().includes('fire') || product.value.name.toLowerCase().includes('exterior')))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_28
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _hoisted_29
                                    ], 64))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(cart))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("h4", null, _toDisplayString(_unref(cart).name), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["product_main", {'stickyPadding' : isSticky.value}])
            }, [
              _createElementVNode("h1", null, _toDisplayString(product.value.name), 1),
              _createElementVNode("div", {
                class: "product-description",
                innerHTML: product.value.description
              }, null, 8, _hoisted_32),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(ProductForm, {
                  product: product.value,
                  onProductUpdate: handleProductUpdate
                }, null, 8, ["product"])
              ])
            ], 2),
            _createVNode(PreHangModal, {
              data: {cartItem: (selections.value as WebsiteItem)},
              "is-pre-hang-modal-open": isPreHangOpen.value,
              "price-adjust": _unref(cart)?.priceAdjust,
              onClosePreHangModal: _cache[4] || (_cache[4] = () => {isPreHangOpen.value = false}),
              onPreHangSave: addToCartSuccess
            }, null, 8, ["data", "is-pre-hang-modal-open", "price-adjust"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", null, [
              _hoisted_35,
              _createElementVNode("p", null, [
                _hoisted_36,
                _createVNode(MailToQuotes)
              ])
            ])
          ]))
  ]))
}
}

})